'use client'

import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import React, { FunctionComponent, PropsWithChildren, useEffect, useState } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

const ReactQueryDevtoolsProduction = React.lazy(() => (
  import('@tanstack/react-query-devtools/build/modern/production.js').then(
    (d) => ({ default: d.ReactQueryDevtools }),
  )
))

const QueryProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const [queryClient] = useState(() => new QueryClient())
  const [showDevtools, setShowDevtools] = useState(false)

  useEffect(() => {
    window.addEventListener('toggleDevtools', () => setShowDevtools((old) => !old))
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
      {showDevtools && (
        <React.Suspense fallback={null}>
          <ReactQueryDevtoolsProduction initialIsOpen={false} />
        </React.Suspense>
      )}
    </QueryClientProvider>
  )
}

export default QueryProvider
